import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { IonicVue } from '@ionic/vue';
import './theme/global.css'
import axios_interceptors from './logic/axios_interceptors';
import mitt from 'mitt'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

if (!localStorage.getItem('theme')) {
  localStorage.setItem('theme', 'dark');
  document.body.classList.add('dark-theme');
} else {
  const theme = localStorage.getItem('theme');
  document.body.classList.remove('light-theme', 'dark-theme');
  if (theme === 'light') document.body.classList.add('light-theme');
  if (theme === 'dark') document.body.classList.add('dark-theme');
}

// Create global event bus
const eventBus = mitt()

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(createPinia())

// Make event bus available globally
app.config.globalProperties.$eventBus = eventBus

router.isReady().then(() => {
  axios_interceptors.init();
  app.mount('#app');
});